export function omitProps(props, ...keys) {
  const next = {
    ...props
  };
  for (const key of keys) {
    delete next[key];
  }
  return next;
}